import { render, staticRenderFns } from "./card_count.vue?vue&type=template&id=4ca2a3bc&scoped=true"
import script from "./card_count.vue?vue&type=script&lang=js"
export * from "./card_count.vue?vue&type=script&lang=js"
import style0 from "./card_count.vue?vue&type=style&index=0&id=4ca2a3bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca2a3bc",
  null
  
)

export default component.exports